import { ScreenHeading } from '../components/molecules/ScreenHeading';

export const PageNotFound = () => {
  return <ScreenHeading title="Page not found" hideContext />;
};
